<template>
    <div class="menu-list-item is-flex is-flex-direction-column"
         :class="{'inactive':meal.locked}">
        <div class="menu-list-item__header">
            <span class="menu-list-item__header--category" :class="{'inactive':meal.locked}">
                {{meal.categoryName}}
            </span>
            <span class="menu-list-item__header--tags" v-for="tag in meal.tags" :key="tag">
                | {{ tag }}
            </span>
        </div>
        <h3 class="menu-list-item__name">{{ meal.name }}</h3>
        <span class="menu-list-item__description">{{ meal.description }}</span>
        <span class="menu-list-item__allergens" @click="showModal(meal)" role="button">Allergene und Zusatzstoffe</span>
        <div class="button-container is-flex is-justify-content-space-between is-align-items-center is-flex-wrap-wrap">
          <OrderButton :enabled="!meal.locked && isActive"/>
        </div>
    </div>
    <Modal v-show="modalVisible" @close="modalVisible = false">
        <div class="modal-header">
            <span class="category-name">
                {{ meal.categoryName }}
            </span>
            <span class="menu-tags" v-for="tag in meal.tags" :key="tag">
                | {{ tag }}
            </span>
        </div>
        <p class="meal">
            <span class="meal-header">{{ meal.name }}</span>
            <span>{{ meal.description }}</span>
        </p>
        <hr>
        <p>
            <span class="headline">Information</span>
            <span>{{ meal.ingredients.map(ingredient => ingredient.name).join(', ') }}</span>
        </p>
        <p>
            <span class="headline">Zusatzstoffe</span>
            <span>{{ meal.foodAdditives.map(foodAdditive => foodAdditive.name).join(', ') }}</span>
        </p>
        <p>
            <span
                class="headline">Stoffe o. Erzeugnisse, die Allergien oder Unverträglichkeiten auslösen können</span>
            <span>{{ meal.allergens.map(allergen => allergen.name).join(', ') }}</span>
        </p>
        <p v-if="hasDGEtag">
            <span class="headline">DGE</span>
            <span>Die Angebote mit der Kennzeichnung „DGE“ entsprechen dem „DGE-Qualitätsstandard für die Verpflegung in Schulen“ und wurden von der Deutschen Gesellschaft für Ernährung e.V. (DGE) als eine Menülinie zertifiziert.</span>
        </p>
    </Modal>
</template>

<script>

import Modal from "@/views/components/ui/Modal"
import OrderButton from "@/views/components/ui/PublicMenuPlan/OrderButton"

export default {
    name: 'PublicMenuPlanDayListItem',
    components: {
      Modal,
      OrderButton,
    },
    props: [
        'meal',
        'isActive',
    ],
    data() {
        return {
            modalVisible: false,
        }
    },
    methods: {
        showModal() {
            this.modalVisible = true
        },
    },
    computed: {
      hasDGEtag() {
        return this.meal.tags.includes('DGE')
      }
    }
}
</script>

<style lang="scss" scoped>
.menu-list-item {
    background-color: $secondary;
    border-radius: 15px;
    padding: 1.5rem 1rem;
    margin-bottom: 1.5rem;

    .button-container {
        position: relative;
    }

    &.inactive {
        color: $dark-grey;
    }

    &__header {
        font-size: $font-size-small;
        margin-bottom: 1em;

        &--category {
            background-color: $primary;
            color: $secondary;
            border-radius: 23px;
            padding: .3rem .6rem;
            font-weight: $font-weight-bold;

            &.inactive {
                background-color: $dark-grey;
            }
        }

        span {
            margin-right: .25rem;
        }
    }

    &__name {
        font-weight: $font-weight-black;
        font-size: $fontsize-headline7;
    }

    &__description {
        font-size: $font-size-small;
        margin-bottom: 1em;
    }

    &__allergens {
        font-size: $font-size-small;
        color: $dark-grey;
        cursor: pointer;
        margin-bottom: 0.8rem;
    }
}

.modal-content {
  hr {
    background-color: $dark-grey;
  }

  p {
    margin-bottom: 1rem;
    font-size: $font-size-small;
  }

  .modal-header {
    margin-bottom: 1rem;
    display: inline-block;

    span {
      font-size: $font-size-small;
    }

    .category-name {
      background: $primary;
      color: $secondary;
      font-weight: $font-weight-black;
      border-radius: 17px;
      padding: 5px 15px;
      margin-right: .25rem;
    }
  }

  .meal {
    .meal-header {
      display: block;
      font-weight: $font-weight-black;
      font-size: $font-size-large;
    }
  }

  .headline {
    display: block;
    font-weight: $font-weight-bold;
  }
}

@media all and (min-width: $desktop) {
    .desktop-list {
        .menu-list-item__header{
            height: 45px;
        }
        span.menu-list-item__description {
            height: 130px;
        }

        h3.menu-list-item__name {
            height: 60px;
        }
    }
    .desktop {
        .menu-list-item {
            float: left;
            width: 49%;
            margin-left: .5%;
            margin-right: .5%;

            @media all and (min-width: $widescreen) {
                width: 32%;
                margin-left: .5%;
                margin-right: .5%;
            }

            @media all and (min-width: $fullhd) {
                width: 24%;
                margin-left: .5%;
                margin-right: .5%;
            }

            span.menu-list-item__description {
                height: 90px;
            }

            h3.menu-list-item__name {
                height: 60px;
            }
        }
    }
}
</style>
